import { render, staticRenderFns } from "./tabZujianChild1.vue?vue&type=template&id=d8adbe34&"
import script from "./tabZujianChild1.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports